















import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as auth from "../../_store/auth.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class ElencoAllieviAssegnatiTutor extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;
  private listaAllievi: any;

  constructor() {
    super();
    this.titleParams = {
      title: "ALLIEVI ASSEGNATI",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Status Patto",
          value: "reviewAutorizzazione",
          sortable: false
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      filterType: "listaAbbinamenti",
      //   alternanzaDialogParams: {
      //     title: "DETTAGLI P.C.T.O.",
      //     type: "infoAlternanzaTab"
      //   },
      type: "allieviAssegnati"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaAllievi = [];
  }

  loadStudentsTutor(idAnnoScolastico:number) {
    // var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var counter: number = 0;
    var payload = {
      idIstituto: 0,
      idAnnoScolastico: idAnnoScolastico,
      idTutor: 0
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo = user.readUserInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idTutor: userInfo.idUtente
    };
    data
      .dispatchAllieviAssegnatiTutor(this["$store"], payload)
      .then(response => {
        this.listaAllievi = response;
        this.dataTableParams.records = response;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var tempList: any[] = [];
    // var indirizziStudioList: any[] = [];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            // data
            //   .dispatchAssegnazioneArticolazione(
            //     this["$store"],
            //     payload.idUtente
            //   )
            //   .then(response => {
            //     response.forEach(element => {
            //       this.dataTableParams.listaArticolazioni.push(element);
            //     });
            data
              .dispatchIndirizziStudioTutorArticolazione(
                this["$store"],
                payload.idUtente
              )
              .then(result => {
                // this.listaIndirizziStudio = result;
                this.loadStudentsTutor(idAnnoScolastico);
                //this.loadSectorRequests(this.listaIndirizziStudio); //non prende la lista corretta perchè il compoennte viene create prima del click
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
              });
            //   })
            //   .catch(error => {
            //     if (error.response.status === 403) {
            //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            //       this["$router"].push("/login");
            //     } else {
            //       bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            //     }
            //   });
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadStudentsTutor(payload);
    });
  }
}
